module.exports = __webpack_public_path__ + "../resources/img/ic_replacement_in_progress.723b1c78.svg";